import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

type Firma = Record<string, string>;
const ALANLAR: { k: string; ad: string; ipucu?: string; genis?: boolean; tip?: string }[] = [
  { k: 'ad', ad: 'Firma adı (unvan)', genis: true },
  { k: 'adres', ad: 'Adres', genis: true },
  { k: 'telefon', ad: 'Telefon' },
  { k: 'eposta', ad: 'E-posta' },
  { k: 'web', ad: 'Web adresi' },
  { k: 'vergiDairesi', ad: 'Vergi dairesi', ipucu: 'Boşsa teklifte görünmez.' },
  { k: 'vergiNo', ad: 'Vergi no', ipucu: 'Boşsa teklifte görünmez.' },
  { k: 'banka', ad: 'Banka ve şube', ipucu: 'Banka ve IBAN boşsa "Banka bilgileri" kutusu çıkmaz.' },
  { k: 'iban', ad: 'IBAN' },
  { k: 'hesapSahibi', ad: 'Hesap sahibi (alıcı)', ipucu: 'Boşsa firma adı yazılır.' },
  { k: 'logoUrl', ad: 'Logo adresi (https://…)', genis: true, ipucu: 'Boşsa firma adı yazıyla basılır.' },
  { k: 'markalar', ad: 'Satışını yaptığınız markalar (virgülle)', genis: true, ipucu: 'Örn. Grohe, Hansgrohe, Duravit, Geberit. Teklifin en altında şerit olarak basılır; boşsa şerit çıkmaz.' },
  { k: 'gecerlilikGun', ad: 'Teklif geçerlilik süresi (gün)', tip: 'number', ipucu: 'Boşsa 15 gün.' },
];

/** Ayarlar › Teklif antedi: teklif PDF'inde basılan firma, vergi ve banka bilgileri. */
export default function FirmaAyar() {
  const { can } = useAuth();
  const [f, setF] = useState<Firma | null>(null);
  const [durum, setDurum] = useState<{ tur: 'ok' | 'hata'; m: string } | null>(null);
  const [mesgul, setMesgul] = useState(false);
  useEffect(() => {
    api<{ satirlar: { key: string; deger: unknown }[] }>('/api/ayarlar')
      .then((r) => {
        const d = (r.satirlar.find((s) => s.key === 'firma')?.deger ?? {}) as Record<string, unknown>;
        setF(Object.fromEntries(ALANLAR.map((a) => [a.k, d[a.k] == null ? '' : String(d[a.k])])));
      })
      .catch(() => setF(Object.fromEntries(ALANLAR.map((a) => [a.k, '']))));
  }, []);
  if (!f) return null;
  const yazabilir = can('settings.write');

  async function kaydet() {
    setMesgul(true); setDurum(null);
    try {
      const deger: Record<string, unknown> = { ...f };
      if (!f!.gecerlilikGun) delete deger.gecerlilikGun; else deger.gecerlilikGun = Number(f!.gecerlilikGun);
      await api('/api/ayarlar/firma', { method: 'PUT', body: JSON.stringify({ deger }) });
      setDurum({ tur: 'ok', m: 'Kaydedildi. Bundan sonra alınan teklif PDF\'lerinde bu bilgiler basılır.' });
    } catch (e) { setDurum({ tur: 'hata', m: e instanceof Error ? e.message : 'Kaydedilemedi' }); }
    finally { setMesgul(false); }
  }

  return (
    <div className="ccd-card ccd-stack-sm" id="firma">
      <div className="ccd-fieldset-title">Teklif antedi</div>
      <div className="ccd-field-hint">Teklif PDF'inde basılan firma, vergi ve banka bilgileri. Boş bırakılan alan teklifte hiç görünmez.</div>
      <div className="ccd-row" style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}>
        {ALANLAR.map((a) => (
          <div key={a.k} className="ccd-field" style={{ flex: a.genis ? '1 1 100%' : '1 1 240px' }}>
            <label className="ccd-field-label" htmlFor={`firma-${a.k}`}>{a.ad}</label>
            <input id={`firma-${a.k}`} className="ccd-input" type={a.tip ?? 'text'} value={f[a.k] ?? ''} disabled={!yazabilir || mesgul}
                   onChange={(e) => setF((x) => ({ ...x!, [a.k]: e.target.value }))} />
            {a.ipucu && <div className="ccd-field-hint">{a.ipucu}</div>}
          </div>
        ))}
      </div>
      {durum && <div className={`ccd-banner${durum.tur === 'hata' ? ' ccd-banner-danger' : ''}`} role="status">{durum.m}</div>}
      {yazabilir && <div><button type="button" className="ccd-btn ccd-btn-primary" disabled={mesgul} onClick={() => void kaydet()}>{mesgul ? 'Kaydediliyor…' : 'Antedi kaydet'}</button></div>}
    </div>
  );
}
